import React, { useState } from 'react';
import styled from 'styled-components';

const ConjRootChangesHelp: React.FC = () => {
  const [showHelp, setShowHelp] = useState(false);

  return (
    <>
      <HelpHeader>
        <HelpToggle
          onClick={(e) => {
            e.preventDefault();
            setShowHelp((v) => !v);
          }}
        >
          {showHelp ? 'Hide help' : 'Show help'}
        </HelpToggle>
      </HelpHeader>
      {showHelp && (
        <HelpBox>
          <HelpTitle>How these rules work</HelpTitle>
          <ul>
            <li>
              <b>Class changes</b>: Built-in class changes still apply. Custom rules here are consulted in addition to
              them; a match by either treats the root diff as CHANGE. The engine can combine one built-in class change
              with one custom rule for the same diff window.
              <ul>
                <li>
                  <code>∅ → X</code>: insert a single letter (one-letter addition in the word).
                </li>
                <li>
                  <code>X → ∅</code>: remove a single letter (one-letter deletion from the stem).
                </li>
                <li>
                  <code>V → V</code>: single vowel changes to a single vowel.
                </li>
                <li>
                  <code>C → C</code>: single consonant changes to a single consonant.
                </li>
                <li>
                  <code>V → VV</code>: single vowel changes to two vowels.
                </li>
              </ul>
            </li>
            <li>
              <b>Priority</b>: Higher <code>priority</code> wins. Ties resolve by lowest <code>id</code>.
            </li>
            <li>
              <b>[V]/[C] tokens</b>: Use <code>[V]</code> for any single vowel and <code>[C]</code> for any single
              consonant in <code>from</code>/<code>to</code>. Each token counts as one slot (max total length 0–4).
            </li>
            <li>
              <b>Ctx ending starts</b>: If set, the rule only applies when the applied ending exists and its first
              letter is one of these characters; otherwise this constraint is ignored.
            </li>
            <li>
              <b>Word class</b>: Optional scope. Leave empty to apply to all word classes.
            </li>
            <li>
              <b>Empty parts</b>: Empty <code>from</code> or <code>to</code> are allowed; if both are empty the rule is
              ignored at runtime.
            </li>
          </ul>
          <HelpExample>
            Example: <code>c → qu</code> with ctx <code>ei</code> matches when the next ending starts with{' '}
            <code>e</code>
            or <code>i</code>.
          </HelpExample>
        </HelpBox>
      )}
    </>
  );
};

const HelpHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 4px;
`;

const HelpToggle = styled.a`
  font-size: 12px;
  color: #3f51b5;
  cursor: pointer;
  text-decoration: underline;
`;

const HelpBox = styled.div`
  padding: 8px 10px;
  margin: 6px 0 10px;
  border: 1px dashed #c8d1ff;
  border-radius: 4px;
  background: #f7f9ff;
  color: #283046;
  font-size: 12px;
  line-height: 1.35;
  & ul {
    margin: 4px 0 0 16px;
  }
`;

const HelpTitle = styled.div`
  font-weight: 600;
  margin-bottom: 4px;
`;

const HelpExample = styled.div`
  margin-top: 6px;
  font-style: italic;
`;

export default ConjRootChangesHelp;
